import * as React from "react";
const SvgFiRrMugMarshmallows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mug-marshmallows_svg__a)">
      <path
        fill="#062147"
        d="M19.5 10.002H19v-1a3.01 3.01 0 0 0-1.934-2.804c.362-.444.559-.994.559-1.575 0-.667-.26-1.295-.732-1.768L14.771.733c-.945-.944-2.592-.944-3.536 0l-.55.55A2.5 2.5 0 0 0 8.503.002h-3a2.504 2.504 0 0 0-2.501 2.5v3q.002.333.084.643A3 3 0 0 0 .999 9.002v10c0 2.757 2.243 5 5 5h8a5.01 5.01 0 0 0 4.899-4h.601c1.93 0 3.5-1.57 3.5-3.5v-3c0-1.93-1.569-3.5-3.499-3.5m-6.851-7.854a.5.5 0 0 1 .708 0l2.122 2.122a.5.5 0 0 1 0 .708l-1.025 1.025h-2.9l-1.025-1.025a.5.5 0 0 1-.034-.67l2.155-2.159zm-7.646.354a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.472a2.504 2.504 0 0 0-.207 3.028H5.503a.5.5 0 0 1-.5-.5zm8.998 19.5H6c-1.654 0-3-1.346-3-3v-10c0-.551.449-1 1-1h12c.551 0 1 .449 1 1v10c0 1.654-1.346 3-3 3zm7-5.5c0 .827-.673 1.5-1.5 1.5h-.5v-6h.5c.827 0 1.5.673 1.5 1.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mug-marshmallows_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMugMarshmallows;
